import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=2ff42a46&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=2ff42a46&lang=less&scoped=true&"
import style1 from "./Activity.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff42a46",
  null
  
)

component.options.__file = "Activity.vue"
export default component.exports